var g = Object.defineProperty;
var m = (t, e, n) => e in t ? g(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var s = (t, e, n) => (m(t, typeof e != "symbol" ? e + "" : e, n), n);
import u from "axios";
import { $ as d } from "./FrontiersClibConfigService.5b50b8d0.js";
function h(t) {
  return new Promise((e) => setTimeout(e, t));
}
var a = /* @__PURE__ */ ((t) => (t[t.pending = 0] = "pending", t[t.waiting = 1] = "waiting", t[t.done = 2] = "done", t))(a || {});
class o {
  constructor() {
    s(this, "mainDomain", "");
  }
  static disableCache() {
    this.ENABLED_CACHE = !1;
  }
  get getMainDomain() {
    return this.mainDomain || (this.mainDomain = d.getMainDomain), this.mainDomain;
  }
}
s(o, "ENABLED_CACHE", !0), s(o, "cache", {
  user_info: {
    data: void 0,
    maxRetries: 15,
    requestStatus: a.pending
  },
  office_suite: {
    data: [],
    maxRetries: 15,
    requestStatus: a.pending
  }
});
class i extends o {
  get userInfoEndpoint() {
    return `https://onboarding-ui.${this.getMainDomain}/api/onboarding-ui/v1/session/logged`;
  }
  getLoggedUserInfo() {
    return i.ENABLED_CACHE === !1 || i.cache.user_info.requestStatus === a.pending ? this.getUserInfoFromAPI() : this.getUserInfoFromCache();
  }
  getUserInfoFromAPI() {
    return new Promise((e, n) => {
      i.cache.user_info.requestStatus = a.waiting;
      const f = {
        withCredentials: !0
      };
      u.get(this.userInfoEndpoint, f).then((r) => {
        i.cache.user_info.data = this.getLoggedUserInfoModel(
          r.data
        ), e(i.cache.user_info.data);
      }).catch((r) => {
        n(r.message);
      }).finally(() => {
        i.cache.user_info.requestStatus = a.done, setTimeout(this.resetCache, 3e5);
      });
    });
  }
  getUserInfoFromCache(e = 0) {
    return e >= i.cache.user_info.maxRetries ? this.getUserInfoFromAPI() : i.cache.user_info.requestStatus === a.waiting ? h(200).then(() => this.getUserInfoFromCache(e + 1)) : new Promise((n, f) => {
      n(i.cache.user_info.data);
    });
  }
  resetCache() {
    i.cache.user_info.requestStatus, a.pending;
  }
  getLoggedUserInfoModel(e) {
    return {
      id: e.userId,
      firstName: e.firstName,
      middleName: e.middleName,
      lastName: e.lastName,
      primaryEmailAddress: e.primaryEmailAddress,
      loopProfileUrl: e.loopProfile,
      profilePicture: e.profilePicture
    };
  }
}
export {
  o as B,
  i as U,
  a as r,
  h as s
};
